import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.decorateFootnotes();
    this.element.addEventListener("click", this.handleClick);
  }


  decorateFootnotes() {
    const footnotes = this.element.querySelectorAll("sup");

    footnotes.forEach(sub => {
      sub.classList.add('footnote');
    });
  }
  disconnect() {
    this.element.removeEventListener("click", this.handleClick);
  }

  handleClick = (event) => {
    const sup = event.target.closest("sup[foot_note]");
    if (!sup) return;

    const footnoteId = sup.getAttribute("foot_note");
    const frame = this.element.querySelector("turbo-frame");

    if (!footnoteId || !frame) return;

    const url = `/footnotes/${footnoteId}`;

    if (frame.src === url && frame.innerHTML.trim() !== "") {
      frame.innerHTML = ""; // Hide footnote
    } else {
      frame.src = url; // Load footnote
    }
  };
}
